import CVSlide from './slides/CVSlide';
import FormSlide from './slides/FormSlide';
import LowSlide from './slides/LowSlide';

export default class Widget {
	constructor() {
		this.widgetWrapper = document.querySelector('[data-ketelomlaag-widget]');

		this.currentSlideIndex = 0;

		this.slide1 = this.widgetWrapper.querySelector('[data-ketelomlaag-slide="1"]');
		this.slide2 = this.widgetWrapper.querySelector('[data-ketelomlaag-slide="2"]');
		this.slide3 = this.widgetWrapper.querySelector('[data-ketelomlaag-slide="3"]');
		this.slide4 = this.widgetWrapper.querySelector('[data-ketelomlaag-slide="4"]');

		this.CVslide = new CVSlide(this.slide2);
		this.lowSLide = new LowSlide(this.slide3);
		this.formSlide = new FormSlide(this.slide4);

		this.slides = [this.slide1, this.slide2, this.slide3, this.slide4];

		this.nextBtns = this.widgetWrapper.querySelectorAll('[data-next]');
		this.nextBtns.forEach((nextbtn) => {
			nextbtn.addEventListener('click', this.validate.bind(this));
		});

		this.backBtns = this.widgetWrapper.querySelectorAll('[data-back]');
		this.backBtns.forEach((backbtn) => {
			backbtn.addEventListener('click', this.back.bind(this));
		});

		this.submitBtns = this.widgetWrapper.querySelectorAll('[data-submit]');
		this.submitBtns.forEach((submit) => {
			submit.addEventListener('click', this.submit.bind(this));
		});
	}

	validate(e, valid = true) {
		e.preventDefault();
		if (this.currentSlideIndex == 1) {
			valid = this.CVslide.validate();

			if (!valid) {
				return;
			}

			const value = this.CVslide.getValue();
			this.lowSLide.setValue(value);
		}

		if (this.currentSlideIndex == 3) {
			valid = this.formSlide.validate();

			if (!valid) {
				return;
			}
		}

		if (valid) {
			this.next();
		}
	}

	back(e) {
		e.preventDefault();
		this.currentSlideIndex = this.currentSlideIndex - 1;

		this.slides.forEach((slide) => {
			slide.classList.remove('is-active');
		});

		this.slides[this.currentSlideIndex].classList.add('is-active');
	}

	next() {
		// Navigation
		this.currentSlideIndex += 1;

		this.slides.forEach((slide) => {
			slide.classList.remove('is-active');
		});

		this.slides[this.currentSlideIndex].classList.add('is-active');

		// Datalayer
		const data = {
			event: `FormComfortStep${this.currentSlideIndex}`,
		};

		switch (this.currentSlideIndex) {
			case 2:
				const brand = this.CVslide.brandDropdown.value;
				const type = window.cvtypes[brand][this.CVslide.typeDropdown.value];
				data.data = {
					brand: brand,
					type: type,
					initialTemperature: this.CVslide.rangeSlider.value,
				};
				break;
			case 3:
				data.data = {
					targetTemperature: this.lowSLide.rangeSlider.value,
				};

				const messageTitle = document.querySelector(`[data-message="${this.lowSLide.rangeSlider.value}"] [data-message-title]`).textContent;
				document.querySelector('[data-title]').textContent = messageTitle;

				break;

			case 4:
				data.data = {
					email: this.slide4.querySelector('[name="email"]').value,
				};
				break;

			default:
				break;
		}

		this.pushToDataLayer(data);
	}

	pushToDataLayer(data) {
		window.dataLayer = window.dataLayer || [];
		dataLayer.push(data);
	}

	submit(e) {
		e.preventDefault();

		if (this.isSubmitting) {
			return;
		}

		this.isSubmitting = true;

		// Datalayer

		this.pushToDataLayer({
			event: `FormComfortStep${this.currentSlideIndex + 1}`
		});

		fetch(this.widgetWrapper.action, {
			method: 'POST',
			body: new FormData(this.widgetWrapper),
		})
			.then((response) => response.json())
			.then((data) => this.displaySuccess(data))
			.catch((error) => this.displayFailure(error))
			.finally(() => (this.isSubmitting = false));
	}

	displaySuccess(data) {
		// console.log(data, data.data.message);
		window.location.href = data.data.message;
	}

	displayFailure(data) {
		document.querySelector('[data-widget-content]').append(`<p>${data.message}</p>`);
	}
}
